import BetslipControllerViewImpl from './controller-view.jsx';
import MojitoCore from 'mojito/core';
import { noop } from 'mojito/utils';
import PropTypes from 'prop-types';

const UIControllerView = MojitoCore.Presentation.UIControllerView;

/**
 * Betslip module.
 *
 * @class BetslipControllerView
 * @extends Mojito.Core.Presentation.UIControllerView
 * @memberof Mojito.Modules.Betslip
 */

/**
 * BetslipControllerView prop types.
 *
 * @property {Function} [onClearReceipt = () => {}] - Callback on receipt clear.
 *
 * @memberof Mojito.Modules.Betslip.BetslipControllerView
 */
const propTypes = {
    onClearReceipt: PropTypes.func,
};

const defaultProps = {
    onClearReceipt: noop,
};

export default UIControllerView(
    'BetslipControllerView',
    BetslipControllerViewImpl,
    propTypes,
    defaultProps
);
